<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="mb-3">
            <Link :href="route('users.index')" class="btn btn-outline-primary">
              <i class="bi bi-plus-circle"></i> &nbsp; Lista użytkowników
            </Link>
          </div>

        </div>

        <div class="widget-content">
          <div v-if="$page.props.errors">
            <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.errors">
              <li class="alert alert-danger">{{ error }}</li>
            </ul>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <h3 class="card-header">Użytkownik</h3>
              <div class="card-body">
                <form @submit.prevent="form.put(route('users.update', form.id))">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-label" for="first_name">Imię</label>
                      <div v-if="form.errors.first_name">{{ form.errors.first_name }}</div>
                      <input class="form-control form-control-sm" id="first_name" v-model="form.first_name"/>
                    </div>

                    <div class="col-md-6">
                      <label class="form-label" for="last_name">Nazwisko:</label>
                      <div v-if="form.errors.last_name">{{ form.errors.last_name }}</div>
                      <input class="form-control form-control-sm" id="last_name" v-model="form.last_name"/>
                    </div>

                    <div class="col-md-6">
                      <label class="form-label" for="position">Stanowisko:</label>
                      <div v-if="form.errors.position">{{ form.errors.position }}</div>
                      <input class="form-control form-control-sm" id="position" v-model="form.position"/>
                    </div>

                    <div class="col-md-6">
                      <label class="form-label" for="department_id">Dział:</label>
                      <div v-if="form.errors.department_id">{{ form.errors.department_id }}</div>
                      <select class="form-select form-select-sm" id="department" v-model="form.department_id">
                        <option value="">Wybierz dział</option>
                        <option v-for="department in departments" :key="department.id" :value="department.id">
                          {{ department.name }}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-6">
                      <label class="form-label" for="short_name">Email</label>
                      <div v-if="form.errors.short_name">{{ form.errors.short_name }}</div>
                      <input class="form-control form-control-sm" id="email" v-model="form.email"/>
                    </div>

                    <div class="col-md-6">
                      <label class="form-label" for="phone">Nr. tel</label>
                      <div v-if="form.errors.phone">{{ form.errors.phone }}</div>
                      <input class="form-control form-control-sm" id="phone" v-model="form.phone"/>
                    </div>

                    <div class="col-md-6">
                      <label class="form-label" for="password">Hasło:</label>
                      <div v-if="form.errors.password">{{ form.errors.password }}</div>
                      <input class="form-control form-control-sm" type="password" id="password"
                             v-model="form.password"/>
                    </div>

                    <div class="col-md-6">
                      <label class="form-label" for="password_confirmation">Powtórz hasło:</label>
                      <div v-if="form.errors.password_confirmation">{{ form.errors.password_confirmation }}</div>
                      <input
                          class="form-control form-control-sm"
                          type="password"
                          id="password_confirmation"
                          v-model="form.password_confirmation"
                      />
                    </div>

                    <div class="col-12 mt-3">
                      <label class="form-label" for="roles">Role:</label>
                      <div v-if="form.errors.role">{{ form.errors.role }}</div>
                      <multiselect
                          id="roles"
                          open-direction="bottom"
                          v-model="form.roles"
                          tag-placeholder="Dodaj jako nowy"
                          placeholder="Szukaj"
                          label="name"
                          track-by="name"
                          :options="options"
                          :multiple="true"
                          :taggable="true"
                          @tag="addTag"
                      />
                    </div>
                  </div>

                  <div class="mt-3" v-if="form.isDirty">Istnieją nie zapisane dane w formularzu.</div>
                  <button class="btn btn-primary mt-3 m-2" type="submit" :disabled="form.processing">Zapisz</button>

                  <button class="float-end btn btn-danger mt-3 m-2" @click="deactivateUser" :disabled="form.processing"
                          v-show="currentUser.is_active">
                    Dezaktywuj Użytkownika
                  </button>

                  <button class="float-end btn btn-success mt-3 m-2" @click="activateUser" :disabled="form.processing"
                          v-show="!currentUser.is_active">
                    Aktywuj Użytkownika
                  </button>
                </form>
              </div>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-md-4 col-sm-12">
              <h3 class="card-header">Uprawnienia niestandardowe</h3>
              <div class="card-body mt-4">
                <table>
                  <tr>
                    <td>
                      <h5>Kontrahenci</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do kontrahentów</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewClients"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>


                  <tr>
                    <td class="pt-5">
                      <h5>Oferty</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do ofert</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewOffers"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Rozszerzony widok ofert</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canSeeExtendedOfferView"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do tworzenia/edytowania ofert</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox"
                               v-model="permissions.canEditOffers"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do edytowania szablonów ofert</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox"
                               v-model="permissions.canEditOffersTemplates"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>

                  <tr>
                    <td class="pt-5">
                      <h5>Oferty Głowice</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do ofert głowic</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewOffersGlowice"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Rozszerzony widok ofert głowic</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canSeeExtendedOfferGlowiceView"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do tworzenia/edytowania ofert głowic</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox"
                               v-model="permissions.canEditOffersGlowice"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do edytowania szablonów ofert głowic</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox"
                               v-model="permissions.canEditOffersGlowiceTemplates"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>


                  <tr>
                    <td class="pt-5">
                      <h5>Projekty</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do projektów</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox"
                               v-model="permissions.canViewProjects"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do projektów głowic</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox"
                               v-model="permissions.canViewProjectsGlowice"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">
                        Podstawowa edycja projektów<br>
                        <small>(Utwórz projekt, edycja nazwy, karta otwarcia zlecenia, zmiana priorytetów)</small>
                      </label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditBasicProject"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">
                        Podstawowa edycja projektów głowic<br>
                        <small>(Utwórz projekt, edycja nazwy, karta otwarcia zlecenia, zmiana priorytetów)</small>
                      </label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditBasicProjectGlowice"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">
                        Zatwierdzanie projektów<br>
                        <small>(Możliwość zatwierdzania w projektach)</small>
                      </label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canApproveProjects"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">
                        Rozszerzona edycja projektów<br>
                        <small>(projekt, kontakty projektu, wybrani dostawcy, ocena ryzyka, numeracja)</small>

                      </label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditAdvancedProject"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Archiwizowanie / przywracanie projektów</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canArchiveRestoreProjects"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Edycja spędzony czas, budżet/koszty projektów</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditTimeSpentAndBudgetProject"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do płatności + status płatności projektów</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewPaymentsProject"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Edycja płatności + status płatności projektów</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditPaymentsProject"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Edycja płatności + status płatności projektów głowic</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditPaymentsProjectGlowice"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do gwarancji projektów</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewWarrantyProject"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Widok harmonogramu</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewScheduleProject"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Edycja harmonogramu</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditResourceSchedule"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Rozsze. widok notatek</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewProjectInfo"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>				  
                </table>
              </div>
            </div>

            <div class="col-md-4 col-sm-12 mt-4 pt-2">
              <div class="card-body mt-4">
                <table>
                  <tr>
                    <td>
                      <h5>Zakupy</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do zakupów</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewPurchases"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Lista artykułów - Widoczność cen artykułów / historii</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewArticlesPricesAndHistory"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Lista artykułów - tworzenie/edycja artykułów</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditArticles"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Lista artykułów - usuwanie artykułów</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canDelArticles"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>				  
				  
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Lista artykułów - Edycja szablonu artykułów</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditArticlesTemplate"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zapotrzebowanie - tylko podgląd</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canRequiredProjectItemsViewOnly"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>				  
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zapotrzebowanie - tworzenie/edycja pozycji</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditRequiredProjectItems"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Wczytaj z inventora</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canUseInventorParser"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zapotrzebowanie - usuwanie pozycji</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canDelRequiredProjectItems"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>				  
				  
                  <tr>
                    <td>
					  <label class="mt-3 me-2">Zatwierdzanie zapotrzebowania projektowego</label>
					</td>
					<td>
					  <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
					  <input type="checkbox" v-model="permissions.canChangeStatusRequiredProjectItems"
					  @change="updatePermissions(this)">
					   <span class="slider round"></span> </label>
					</td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zapytania ofertowe - podgląd</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewQuoteRequests"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zapytania ofertowe - tworzenie/edycja zapytań</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditQuoteRequests"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zamówienia - podgląd</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewOrders"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zamówienia w zatwierdzeniu - zmiana statusu mag.</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canChangeStatusApprovalOrders"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zamówienia - tworzenie/edycja zamówień</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditOrders"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Ruchy magazynowe - podgląd</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewWarehouseMovements"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Stany magazynowe - podgląd</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewWarehouse"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Stany magazynowe - dyspozycja magazynowa</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canWarehouseDispositions"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Opisy faktur</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewOpisyFaktur"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Ustawienia kretora</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canCreatorSettings"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>				  
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Ustawienia</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canZakupySettings"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Statystyki zakupów - dostęp</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canZakupyStats"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
				  
                  <tr>
                    <td class="pt-5">
                      <h5>Kadry / Urlopy</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do kadr</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canViewKadry" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Urlopy pracowników działu</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canViewUrlopyDzial"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <label class="mt-3 me-2">Urlopy wszystkich pracowników</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canViewUrlopy" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dodawanie wniosków</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canAddUrlop" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zatwierdzanie wniosków</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canAcceptUrlop" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Odrzucanie wniosków</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canRejectUrlop" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Edycja wniosków</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canEditUrlop" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Usuwanie wniosków</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canDelUrlop" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dodawanie zwolnień L4</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canAddL4" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Lista i dane pracowników</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canViewWorkersDane" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Kadry - edycja ustawień</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canEditKadry" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do dysków</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canViewSMBUsers" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
				  
                  <tr>
                    <td class="pt-5">
                      <h5>Księgowość</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do księgowości</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canViewKsiegowosc" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>



                  <tr>
                    <td class="pt-5">
                      <h5>BHP</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do BHP</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canViewBHP" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dodawanie/edycja danych</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canEditBHP" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Usuwanie danych</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canDelDataBHP" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td class="pt-5">
                      <h5>Odzież ochronna</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do odzieży</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canViewUbrania" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dodawanie/edycja odzieży</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canEditUbrania" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Usuwanie odzieży</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canDelUbrania" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="col-md-4 col-sm-12 mt-4 pt-2">
              <div class="card-body mt-4">
                <table>

                  <tr>
                    <td>
                      <h5>Serwis</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do serwisu</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewService"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Widoczność kwoty zgłoszenia</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewClientPrice"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Edycja kosztów zgłoszenia</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewServiceCosts"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do plików zgłoszenia</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewServiceFiles"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do plików PDF</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canServicePDF"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dodawanie zgłoszeń</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canAddService"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Edycja zgłoszeń</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditService"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zmiana statusu zgłoszenia</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canChangeServiceStatus"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Usuwanie zgłoszeń</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canDelService"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do stawek serwisowych</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewRate"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dodawanie/edycja stawek serwisowych</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canAddEditRate"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Usuwanie stawek serwisowych</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canDelRate"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do kategorii serwisowych</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewServiceCategory"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dodawanie kategorii serwisowych</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canAddServiceCategory"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Edycja kategorii serwisowych</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canEditServiceCategory"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Usuwanie kategorii serwisowych</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canDelServiceCategory"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostępo do zestawień</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewSerwisZestawienia"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>

                  <tr>
                    <td class="pt-5">
                      <h5>Pracownik</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Widok odbić karty</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewCardRead"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do czasu pracy</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewWorktime"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dodawanie czasu pracy</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canAddWorktime"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zestawienia czasu pracy</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewWorktimes"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>

                  <tr>
                    <td class="pt-5">
                      <h5>Salki konferencyjne</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do harmonogramu</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canViewConferenceRoom"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dodawanie wpisów do harmonogramu</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canAddConferenceRoom"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dodawanie salek</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input
                            type="checkbox"
                            v-model="permissions.canAddConferenceRooms"
                            @change="updatePermissions(this)"
                        >
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td class="pt-5">
                      <h5>Produkcja</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do produkcji</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canViewProdukcja" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2"><strong>Produkcja zewnętrzna:</strong></label>
                    </td><td></td>
                  </tr>				  
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do produkcji zewnętrznej</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canViewProdukcjaZewn" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do Status produkcji</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canViewCheckProdukcja" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
				  <tr>
                    <td>
                      <label class="mt-3 me-2"><strong>Produkcja Maszyny:</strong></label>
                    </td><td></td>
                  </tr>				  
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Dostęp do produkcja maszyny</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canViewMaszyny" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Edycja kW/h w Maszyny</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canEditMaszyny" @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>				  
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zamówienia zewnętrzne - dodawanie</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canAddProdukcjaOut"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zamówienia zewnętrzne - usuwanie</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canDelProdukcjaOut"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Zamówienia zewnętrzne - edycja</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canEditProdukcjaOut"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Kontrahenci - dodawanie/edycja</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canAddOutProducent"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Kontrahenci - usuwanie</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canDelOutProducent"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Statusy - dodawanie/edycja</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canAddproductionOutStatus"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="mt-3 me-2">Statusy - usuwanie</label>
                    </td>
                    <td>
                      <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                        <input type="checkbox" v-model="permissions.canDelproductionOutStatus"
                               @change="updatePermissions(this)">
                        <span class="slider round"></span> </label>
                    </td>
                  </tr>
	  
				  
                </table>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </AppLayout>
</template>

<script>

import {Link, useForm} from "@inertiajs/vue3";
import AppLayout from "@/Layouts/App.vue";
import Multiselect from '@suadelabs/vue3-multiselect';
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";

export default {
  components: {AppLayout, Link, Multiselect},
  props: {
    currentUser: Object,
    roles: Array,
    departments: Object
  },
  setup(props) {
    let data = {
      id: props.currentUser.id,
      first_name: props.currentUser.first_name,
      last_name: props.currentUser.last_name,
      position: props.currentUser.position,
      department_id: props.currentUser.department_id || '',
      email: props.currentUser.email,
      phone: props.currentUser.phone,
      password: null,
      password_confirmation: null,
      roles: props.currentUser.roles
    };
    const form = useForm(data)

    return {form, departments: props.departments}
  },
  data() {
    return {
      options: this.roles,
      permissions: Object,
    };
  },
  mounted() {
    this.permissions = this.$page.props.permissions;

    // trzeba ustawić jakąkolwiek wartość, bo inaczej, jak nie ma uprawnień to się nie zapisują
    if (this.permissions.length === 0) {
      this.permissions = {canSeeExtendedOfferView: false};
    }
  },
  methods: {
    addTag(newTag) {
      const tag = {
        name: newTag.name,
      };
      this.options.push(tag);
      this.value.push(tag);
    },

    async activateUser(event) {
      event.preventDefault();
      if (confirm("Czy na pewno chcesz aktywować tego użytkownika?")) {
        this.form.post(route('users.activate', this.form.id));
      }
    },

    async deactivateUser(event) {
      event.preventDefault();
      if (confirm("Czy na pewno chcesz zdezaktywować tego użytkownika?")) {
        this.form.post(route('users.deactivate', this.form.id));
      }
    },

    updatePermissions() {
      axios.post(route('user.updatePermissions', {'user': this.currentUser.id}), {
        permissions: this.permissions
      })
          .then(response => {
            Toast.fire({
              position: 'top-end',
              toast: true,
              icon: 'success',
              title: 'Sukces',
              html: 'Poprawnie zapisano nowe uprawnienia',
              showClass: {popup: 'animate__animated animate__fadeInDown'},
              hideClass: {popup: 'animate__animated animate__fadeOutUp'},
              timer: 2500,
              timerProgressBar: true,
              showConfirmButton: false,
              showCloseButton: true
            });
          })
          .catch(error => {
            console.log(error.response.data.message);
            Toast.fire({
              position: 'top-end',
              toast: true,
              icon: 'error',
              title: 'Błąd',
              html: error.response.data.message,
              showClass: {popup: 'animate__animated animate__fadeInDown'},
              hideClass: {popup: 'animate__animated animate__fadeOutUp'},
              timer: 2500,
              timerProgressBar: true,
              showConfirmButton: false,
              showCloseButton: true
            });
          });
    }


  }
}
</script>
